/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import firebase from "../../../config/firebase";
import store from "../../../containers/App/store";
import { sendEmail } from "../../../redux/actions/jobsActions";
import {
  Card,
  CardBody,
  Col,
  Table,
  Badge,
  Collapse,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Spinner
} from "reactstrap";
import ReactHTMLParser from "react-html-parser";
import { getJobWithId } from "../../../redux/middlewares/Jobs/get_jobs";
import { withRouter } from "react-router-dom";
import { JOB_PATH } from "../../../URLs";
import EditJob from "../../Edit/components/EditJob";
import "./viewJob.style.scss";
import {
  getCompanyWithId,
  getCurrentCompany
} from "../../../redux/middlewares/Company/getCompany";
import { job_activated } from "../../../redux/middlewares/Jobs/post_job";

import { toast } from "react-toastify";

const fromMiliSecondsToDate = seconds => new Date(seconds).toLocaleDateString();

const JobDetails = props => {
  const [job, setJob] = useState(undefined);
  const [company, setCompany] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [isOpenStatusDrop, setIsOpenStatusDrop] = useState(false);
  const [statusChanged, setStatusChanged] = useState(false);
  const [status, setStatus] = useState("");
  const [isFeatureChanged, setIsFeatureChanged] = useState(false);
  const [isFeature, setIsFeature] = useState(false);
  const [loadingIsFeature, setLoadingIsFeature] = useState(false);
  const [modal, setModal] = useState(false);
  const [permision, setPermision] = useState(false);

  // Callbacks
  const toggleDelete = () => setModal(!modal);
  const toggle = () => setIsOpen(!isOpen);
  const toggleStatusDrop = () => setIsOpenStatusDrop(!isOpenStatusDrop);

  const toggleEditModal = () => {
    // CallCompany();
    setEditOpen(!isEditOpen);
  };
  const callDataFromDB = id => {
    getJobWithId(id)
      .then(docs => {
        // console.log(docs);
        if (docs.exists) {
          setJob({ ...docs.data(), id: docs.id });
          setLoading(false);
          // console.log(docs.data());
        }
      })
      .catch(error => console.log(error));
  };

  // useEffect(() => {
  //   effect
  //   return () => {
  //     cleanup
  //   }
  // }, [props.currentCompany])
  const mounted = useRef(false);
  useEffect(() => {
    console.log("did mount", props.email_res);
    // if (mounted.current) {
    if (props.email_res === "send") {
      console.log(props.email_res, "did update email");
      setPermision(!permision);
      setLoading(false);
      store.dispatch(sendEmail(undefined));
      toast.success("Successfully email sent");
      // setModal(!modal)
      // alert('send')
    } else {
      props.email_res !== undefined && alert(props.email_res);
    }

    if (props.job) {
      setJob(props.job);
      setLoading(false);
    } else {
      const { id } = props;
      // setLoading(true);
      callDataFromDB(id);
    }
    return () => {
      setJob(undefined);
      setLoading(false);
    };
  }, [props.email_res]);

  // console.log(job);

  const onClickStatus = e => {
    const current = e.target.value;
    setStatus(current);
    if (current !== job.status) {
      setStatusChanged(true);
    } else setStatusChanged(false);
  };

  const onChangeIsFeature = val => {
    console.log({ val, isF: job.isFeature });
    setIsFeature(val);
    if (val !== job.isFeature) {
      setIsFeatureChanged(true);
    } else setIsFeatureChanged(false);
  };

  const updateStatusHandler = send_with_email => {
    // alert('clicked')
    console.log(job, send_with_email);
    // return;
    setLoading(true);
    const newStatus = status.toLowerCase();
    setStatus("...");
    const jobRef = firebase
      .firestore()
      .collection("jobs")
      .doc(job.id);
    jobRef
      .update({ status: newStatus })
      .then(res => {
        if (send_with_email === true) {
          let data = {
            selectedJob: props?.job,
            newStatus
          };
          props.job_activated(data);
        }
        console.log(
          "after email send if email",
          send_with_email === true && props.email_res
        );
        setStatus(newStatus);
        if (props.job) props.updateStatusInParent(job.id, newStatus);
        setStatusChanged(false);
        if (send_with_email !== true) {
          console.log("done not email ");
          setLoading(false);
          if (props.toggleParentModal) props.toggleParentModal();
        }
      })
      .catch(error => {
        setStatusChanged(false);
        setStatus(job.status);
        alert(error.message);
        setLoading(false);
      });
  };

  // updating Is Feature
  const updateIsFeatureHandler = () => {
    // alert('clicked')
    // console.log(job);
    setLoadingIsFeature(true);
    const jobRef = firebase
      .firestore()
      .collection("jobs")
      .doc(job.id);
    jobRef
      .update({ isFeature: isFeature })
      .then(res => {
        // setStatus(isFeature);
        if (props.updateIsFeatureInParent)
          props.updateIsFeatureInParent(job.id, isFeature);
        setLoadingIsFeature(false);
        setIsFeatureChanged(false);
      })
      .catch(error => {
        setIsFeatureChanged(false);
        setIsFeature(job.status);
        alert(error.message);
        setLoading(false);
      });
  };

  const deleteHandler = () => {
    // console.log({ job });
    let currJob = { ...job };
    console.log({del_id:currJob.id})
    firebase
    .firestore()
    .collection("deleted-jobs")
    .doc(currJob.id)
    .set({
      ...currJob
    })
    .then(res => {
      console.log({res})
      const jobRef = firebase
        .firestore()
        .collection("jobs")
        .doc(currJob.id);
      jobRef
        .delete()
        .then(() => {
          console.log({ currJob });
          let companyRef = firebase.firestore().collection("companies");
          companyRef
            .doc(currJob.company.id)
            .get()
            .then(async res => {
              if (res.exists) {
                let hiring = res.data().jobsPosted > 1 ? true : false;
                await res.ref.update({
                  jobsPosted: firebase.firestore.FieldValue.increment(-1),
                  hiring
                });
              }
            });
          setJob(undefined);
          setLoading(false);
          setModal(false);
          if (props.onJobDeleteSuccess) props.onJobDeleteSuccess(currJob.id);
          else props.history.goBack();
          toast.success("Deleted Successfully!");
        })
        .catch(err => {
          alert("Error: " + err.message);
        });
    })
    .catch(err => console.error({err:err.message}))
  };

  const CallCompany = async () => {
    try {
      getCurrentCompany(job.company.email);
      // const companyDoc = await getCompanyWithId(job.company.id);
      // if (companyDoc.exists) {
      //   console.log({ data: companyDoc.data() });
      //   setCompany(companyDoc.data());
      // } else {
      //   alert("Company Doesn't Exists.");
      // }
    } catch (error) {
      alert(error?.message || "Something went wrong!");
      console.error(error);
    }
  };

  const EditModal = () => {
    return (
      <Modal
        isOpen={isEditOpen}
        toggle={toggleEditModal}
        className="edit-job-modal"
      >
        <ModalHeader toggle={toggleEditModal}>Edit Job</ModalHeader>
        <ModalBody>
          {/* {!props.currentCompany.name ? ( */}
          {/* <Spinner animation="border" variant="info" /> */}
          {/* ) : ( */}
          <EditJob job={job} />
          {/* )} */}
        </ModalBody>
        <ModalFooter>
          {/* <Button
            color="primary"
            onClick={deleteHandler}
            size="sm"
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>{" "} */}
          <Button color="secondary" onClick={toggleEditModal} size="sm">
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const togglePermision = () => {
    alert("toggler");
    setPermision(!permision);
  };

  const statusDropDown = () => (
    <ButtonDropdown isOpen={isOpenStatusDrop} toggle={toggleStatusDrop}>
      <Button id="caret" color="success" size="xs">
        {status || job.status}
      </Button>
      <DropdownToggle caret color="success" />
      <DropdownMenu>
        <DropdownItem value="pending" onClick={onClickStatus}>
          pending
        </DropdownItem>
        <DropdownItem value="active" onClick={onClickStatus}>
          active
        </DropdownItem>
        <DropdownItem value="in-active" onClick={onClickStatus}>
          in-active
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
  // const isFeatureDropDown = () => (
  //   <ButtonDropdown isOpen={isOpenStatusDrop} toggle={toggleStatusDrop}>
  //     <Button id="caret" color="success" size="xs">
  //       {status || job.status}
  //     </Button>
  //     <DropdownToggle caret color="success" />
  //     <DropdownMenu>
  //       <DropdownItem value="pending" onClick={onClickStatus}>
  //         pending
  //       </DropdownItem>
  //       <DropdownItem value="active" onClick={onClickStatus}>
  //         active
  //       </DropdownItem>
  //       <DropdownItem value="in-active" onClick={onClickStatus}>
  //         in-active
  //       </DropdownItem>
  //     </DropdownMenu>
  //   </ButtonDropdown>
  // );
  return (
    <React.Fragment>
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            {job && (
              <>
                <Row>
                  <Col md={3}>
                    <div className="card__title">
                      {" "}
                      <h5 className="bold-text">Job Details</h5>
                    </div>
                  </Col>
                  {props.user?.admin === true && (
                    <Col md={3}>
                      <Button color="danger" size="sm" onClick={toggleDelete}>
                        Delete Job
                      </Button>{" "}
                      <Modal isOpen={modal} toggle={toggleDelete}>
                        <ModalHeader toggle={toggleDelete}>Delete</ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this job ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            onClick={deleteHandler}
                            size="sm"
                            disabled={loading}
                          >
                            {loading ? "Deleting..." : "Delete"}
                          </Button>{" "}
                          <Button
                            color="secondary"
                            onClick={toggleDelete}
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </Col>
                  )}
                  <Col md={3}>
                    <a href={JOB_PATH(job)} target="_blank">
                      <Button color="primary" size="sm">
                        Preview Job
                      </Button>
                    </a>
                  </Col>
                  <Col md={3}>
                    {props.user.dataEntry && job.status !== "pending" ? (
                      ""
                    ) : (
                      <>
                        <Button
                          color="warning"
                          size="sm"
                          onClick={toggleEditModal}
                        >
                          Edit Job
                        </Button>
                        <EditModal />
                      </>
                    )}
                  </Col>
                </Row>
                <Table>
                  <tbody>
                    <tr>
                      <th> Title: </th>
                      <td>
                        <b> {job.title} </b>
                      </td>
                    </tr>
                    <tr>
                      <th> Category: </th>
                      <td style={{}}>
                        <span
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "rgba(240, 62, 62, 0.1)",
                            padding: "0.5em 0.97em",
                            fontSize: "0.9em",
                            color: "#f03e3e"
                          }}
                        >
                          {job.category}
                        </span>{" "}
                      </td>
                    </tr>
                    <tr>
                      <th> Posted At: </th>
                      <td>
                        {fromMiliSecondsToDate(job.postedAt.seconds * 1000)}
                      </td>
                    </tr>
                    <tr>
                      <th> Type: </th>
                      <td> {job.type} </td>
                    </tr>
                    {job.salary && (
                      <tr>
                        <th> Salary: </th>
                        <td> {job.salary} </td>
                      </tr>
                    )}
                    <tr>
                      <th> Regional Restriction: </th>
                      <td> {job.location} </td>
                    </tr>
                    <tr>
                      <th> Description: </th>
                      <td>
                        <div>
                          <Button color="primary" onClick={toggle} size="sm">
                            View Description
                          </Button>
                          <Collapse isOpen={isOpen}>
                            <Card>
                              <CardBody>
                                {ReactHTMLParser(job.description)}
                              </CardBody>
                            </Card>
                          </Collapse>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th> Company: </th>
                      <td> {job.company.name} </td>
                    </tr>
                    <tr>
                      {/* <button onClick={()=>props.sendJob()} > sended  </button> */}
                      <th> Status: </th>
                      <td>
                        {!props.user?.admin === true ? (
                          <h4>
                            <Badge color="success"> {job.status} </Badge>{" "}
                          </h4>
                        ) : (
                          <>
                            {statusDropDown()}{" "}
                            {statusChanged && (
                              <div>
                                <button
                                  onClick={() => {
                                    job?.postType === "external"
                                      ? setPermision(!permision)
                                      : updateStatusHandler(false);
                                  }}
                                  style={{
                                    background: "none",
                                    color: "#FFC107",
                                    border: "1px solid #FFC107",
                                    padding: ".3em .7em"
                                  }}
                                  disabled={loading}
                                >
                                  Update
                                </button>{" "}
                                <button
                                  onClick={() => setStatusChanged(false)}
                                  style={{
                                    background: "none",
                                    color: "red",
                                    border: "1px solid red",
                                    padding: ".3em .7em"
                                  }}
                                  disabled={loading}
                                >
                                  Cancel
                                </button>
                              </div>
                            )}
                            <Modal isOpen={permision} toggle={togglePermision}>
                              <ModalHeader toggle={togglePermision}>
                                Email Permision
                              </ModalHeader>
                              <ModalBody>You want to send email</ModalBody>
                              <ModalFooter>
                                <Button
                                  color="danger"
                                  onClick={() => updateStatusHandler(true)}
                                  size="sm"
                                  disabled={loading}
                                >
                                  {loading ? "Sending..." : "Send Email"}
                                </Button>{" "}
                                <Button
                                  color="primary"
                                  onClick={() => updateStatusHandler(false)}
                                  size="sm"
                                  disabled={loading}
                                >
                                  {loading ? "loading..." : "Change status"}
                                </Button>
                              </ModalFooter>
                            </Modal>
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Is Feature */}
                    <tr>
                      <th> Is Feature: </th>
                      <td>
                        {!props.user?.admin === true ? (
                          <h4>
                            <Badge color="success">
                              {" "}
                              {job.isFeature || "false"}{" "}
                            </Badge>{" "}
                          </h4>
                        ) : (
                          <>
                            {/* {console.log("job=====", job.isFeature)} */}
                            <input
                              type="radio"
                              name="isFeature"
                              id=""
                              value={true}
                              checked={job.isFeature}
                              onChange={() => onChangeIsFeature(true)}
                            />{" "}
                            True
                            <input
                              type="radio"
                              name="isFeature"
                              id=""
                              value={false}
                              checked={!job.isFeature}
                              onChange={() => onChangeIsFeature(false)}
                              style={{ marginLeft: "10px" }}
                            />{" "}
                            False
                            {isFeatureChanged && (
                              <div>
                                <button
                                  onClick={updateIsFeatureHandler}
                                  style={{
                                    background: "none",
                                    color: "#FFC107",
                                    border: "1px solid #FFC107",
                                    padding: ".3em .7em"
                                  }}
                                  disabled={loadingIsFeature}
                                >
                                  Update
                                </button>{" "}
                                <button
                                  onClick={() => setIsFeatureChanged(false)}
                                  style={{
                                    background: "none",
                                    color: "red",
                                    border: "1px solid red",
                                    padding: ".3em .7em"
                                  }}
                                  disabled={loadingIsFeature}
                                >
                                  Cancel
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <th> Expires At: </th>
                      <td> {fromMiliSecondsToDate(job.expiresAt)} </td>
                    </tr>
                  </tbody>
                </Table>

                {/* Company */}
                <div className="card__title">
                  <h5 className="bold-text">Company Details</h5>
                </div>
                <Table>
                  <tbody>
                    <tr>
                      <th> Name: </th>
                      <td>
                        <b> {job.company.name} </b>
                      </td>
                    </tr>
                    <tr>
                      <th> Email: </th>
                      <td> {job.company.email} </td>
                    </tr>
                    <tr>
                      <th> Website: </th>
                      <td>
                        <a
                          href={job.company.websiteURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {job.company.websiteURL}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th> Company HQ: </th>
                      <td> {job.company.companyHQ} </td>
                    </tr>
                    <tr>
                      <th> Confirmation Email: </th>
                      <td> {job.company.confirmationEmail} </td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  // currentCompany: state.companyReducer.currentCompany,
  user: state.authReducer.user,
  email_res: state.jobReducer.email_res
});

export default connect(mapStateToProps, { job_activated })(
  withRouter(JobDetails)
);
